<template>
    <settings
        v-bind:title="resource('TemplateColumnSettings_Settings_Title')"
        v-bind:region="'right'"
        v-bind:tooltip="tooltip"
        class="column-settings"
    >
        <template v-slot:body>
            <settings-media-picker
                    class="form-group"

                    v-bind:label="resource('TemplateManager_Shared_BackgroundMediaId_Label')"
                    v-bind:media-id="model.style.mediaId"
                    @file-picked="model.style.mediaId = $event"
            >
            </settings-media-picker>

            <div class="row">
                <div class="col-12">
                    <settings-dropdown 
                        v-bind:options="backgroundFillOptions"
                        v-bind:label="'Background size'"
                        v-bind:textField="'text'"
                        v-bind:valueField="'value'"
                        v-model="model.style.backgroundSize"
                    />
                </div>
            </div>
            
            <settings-media-cropper
                    class="form-group"

                    v-if="hasImage"
                    v-bind:label="resource('TemplateManager_Shared_OpenMediaCropper_Button_Text')"
                    v-bind:media-id="model.style.mediaId"

                    @image-cropped="imageCropped($event.mediaId, $event.crop)"
            >
            </settings-media-cropper>

            <settings-color-picker
                    v-bind:label="resource('TemplateManager_Shared_BackgroundColor_Label')"
                    v-model="model.style.backgroundColor"
            >
            </settings-color-picker>

            <settings-slider
                    v-bind:label="resource('TemplateManager_Shared_Opacity_Label')"
                    v-model="model.style.opacity"
                    v-bind:value-suffix="'%'"
            >
            </settings-slider>
        </template>
    </settings>
</template>

<script>
    import {elementSettingsTooltip} from "../../tooltips";
    import columnSettingsMixin from '../../Mixins/settings';
    import resourceMixin from "../../../../Util/Mixins/resources";
    import SettingsDropdown from '../Settings/SettingsDropdown.vue';
    
    export default {
        name: "template-column-settings",
        components: {
            SettingsDropdown
        },
        mixins: [resourceMixin, columnSettingsMixin],
        methods: {
            imageCropped(mediaId, crop){
                const vm = this;
                
                vm.model.style.mediaId = mediaId;
                vm.model.style.crop = crop;
            }
        },
        data(){
            return {
                tooltip: elementSettingsTooltip,
                backgroundFillOptions: [
                    {text: 'auto', value: 'auto'},
                    {text: 'contain', value: 'contain'},
                    {text: 'cover', value: 'cover'},
                    {text: 'inherit', value: 'inherit'},
                    {text: 'initial', value: 'initial'},
                    {text: 'unset', value: 'unset'}
                ]
            }
        },
        computed: {
            hasImage(){
                const vm = this;
                
                return !!vm.model.style.mediaId;
            }
        }
    };
</script>
